<template>
  <div>
    <el-card class="mx-2 my-2">
      <el-row :gutter="20">
        <el-col :span="8" class="mt-3">
          <h>Export Farmer Details With Farm Data</h>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" style="float: right;" icon="el-icon-download" @click="exportFarmerData">
            Export
          </el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="mx-2 my-2">
      <el-row>
        <el-col :span="3" class="mt-3">
          <h>Export Travel Details</h>
        </el-col>
        <el-col :span="2">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          />
        </el-col>
        <el-col :span="8">
          <el-button type="primary" style="float: right;" icon="el-icon-download" @click="exportTravelData">
            Export
          </el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import Axios from "axios";
import { format } from "date-fns";
import { forceFileDownload } from "../../utils/utils";
export default {
  name: "ReportDownload",
  computed: {},
  data() {
    return {
      dateRange: "",
      isMounted: false,
    };
  },
  methods: {
    async onInit() {},
    async exportFarmerData() {
      try {
        const response = await Axios.get(`/reports/export-farmers`, { responseType: "arraybuffer" });
        forceFileDownload(response, "Farmers");
      } catch (error) {
        console.log(JSON.stringify(error));
      }
    },
    async exportTravelData() {
      let startDate = format(this.dateRange[0], "yyyy-MM-dd");
      let endDate = format(this.dateRange[1], "yyyy-MM-dd");

      try {
        const response = await Axios.get(`/reports/exportTravelData?startDate=${startDate}&endDate=${endDate}`, {
          responseType: "arraybuffer",
        });
        forceFileDownload(response, `Travel details from ${startDate} to ${endDate}`);
      } catch (error) {
        console.log(JSON.stringify(error));
      }
    },
  },
  async mounted() {
    await this.onInit();
    this.isMounted = true;
  },
};
</script>
<style>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>
